export const industries: { value: string, text: string }[] = [
    { value: "", text: "選択してください" },
    { value: "category_1", text: "パソコン" },
    { value: "category_2", text: "ネットサービス・アプリ" },
    { value: "category_3", text: "デジタル製品・家電" },
    { value: "category_4", text: "企業向けシステム・通信・機器" },
    { value: "category_5", text: "流通" },
    { value: "category_6", text: "エンタテイメント" },
    { value: "category_7", text: "出版・アート・カルチャー" },
    { value: "category_8", text: "ゲーム・おもちゃ" },
    { value: "category_9", text: "スポーツ・アウトドア" },
    { value: "category_10", text: "自動車・バイク" },
    { value: "category_11", text: "インテリア・雑貨" },
    { value: "category_12", text: "アパレル・ファッション" },
    { value: "category_13", text: "食品・飲料" },
    { value: "category_14", text: "外食・中食" },
    { value: "category_15", text: "美容・健康" },
    { value: "category_16", text: "医療・医薬・福祉" },
    { value: "category_17", text: "暮らし" },
    { value: "category_18", text: "ホテル・レジャー" },
    { value: "category_19", text: "住宅・建築・建設" },
    { value: "category_20", text: "教育・資格・人材" },
    { value: "category_21", text: "金融" },
    { value: "category_22", text: "広告・マーケティング" },
    { value: "category_23", text: "ビジネス・コンサルティング" },
    { value: "category_24", text: "交通・運輸・輸送" },
    { value: "category_25", text: "素材・化学・エネルギー" },
    { value: "category_26", text: "自然・環境" },
    { value: "category_27", text: "その他" },
];

export const industry_details: {} = {
    category_1: ["パソコン・周辺機器", "パソコンソフトウェア", "プロバイダ・回線接続"],
    category_2: ["ネットサービス", "スマートフォンアプリ", "スマートフォンゲーム"],
    category_3: ["モバイル端末", "カメラ", "AV機器", "調理・生活家電", "健康・美容家電"],
    category_4: ["サーバー・周辺機器", "ネットワーク・ネットワーク機器", "アプリケーション・セキュリティ", "システム・Webサイト・アプリ開発", "電子部品・半導体・電気機器"],
    category_5: ["百貨店・スーパー・コンビニ・ストア", "EC・通販", "卸売・問屋"],
    category_6: ["芸能", "映画・演劇・DVD", "音楽", "テレビ・CM"],
    category_7: ["雑誌・本・出版物", "漫画・アニメ", "アート・カルチャー"],
    category_8: ["コンシューマーゲーム", "アーケードゲーム", "おもちゃ・遊具・人形"],
    category_9: ["スポーツ", "アウトドア・登山"],
    category_10: ["自動車・カー用品", "バイク・バイク用品"],
    category_11: ["インテリア・家具・収納", "日用品・生活雑貨", "ガーデ二ング・DIY"],
    category_12: ["レディースファッション", "メンズファッション", "シューズ・バッグ", "ジュエリー・アクセサリー", "キッズ・ベビー・マタニティ"],
    category_13: ["食品・お菓子", "ソフトドリンク・アルコール飲料"],
    category_14: ["レストランファストフード・居酒屋", "中食・宅配"],
    category_15: ["スキンケア・化粧品・ヘア用品", "ダイエット・健康食品・サプリメント", "フィットネス・ヘルスケア"],
    category_16: ["医療・病院", "医薬・製薬", "福祉・介護・リハビリ"],
    category_17: ["ペット・ペット用品", "ギフト・花", "恋愛・結婚", "出産・育児", "葬儀"],
    category_18: ["ホテル・旅館", "旅行・観光", "テーマパーク・遊園地"],
    category_19: ["住宅・マンション", "商業施設・オフィスビル", "建築・空間デザイン", "建設・土木"],
    category_20: ["就職・転職・人材派遣・アルバイト", "資格・留学・語学", "学校・大学", "学習塾・予備校・通信教育", "保育・幼児教育"],
    category_21: ["銀行・信用金庫・信用組合", "クレジットカード・ローン", "証券・FX・投資信託", "生命保険・損害保険"],
    category_22: ["広告・宣伝・PR", "マーケティング・リサーチ", "セールス・営業"],
    category_23: ["経営・コンサルティング", "シンクタンク", "財務・経理", "法務・特許・知的財産"],
    category_24: ["交通・運送・引越し", "物流・倉庫・貨物"],
    category_25: ["鉄鋼・金属・ガラス・土石・ゴム", "化学", "電気・ガス・資源・エネルギー"],
    category_26: ["自然・天気", "環境・エコ・リサイクル"],
    category_27: ["政治・官公庁・地方自治体", "財団法人・社団法人・宗教法人", "ボランティア", "国際情報・国際サービス", "農林・水産", "その他"],
};

export const growth_phases: string[] = [
    "",
    "起業準備中",
    "シード / アーリー：累計調達1億未満",
    "シリーズA：累計調達3億未満",
    "シリーズB以降（Middle）：累計調達3億以上",
    "中小企業：エクイティ調達予定無",
];

export const thousand: number = 1000;
export const sizeLimit: number = 1024 * 1024 * 100; // 100MB